export default __webpack_public_path__ + "static/media/Andorra2015.ab29c623.jpg";